module.exports = __webpack_public_path__ + "static/media/wan.c58949f8.svg";